import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDTypography from "../../components/MDTypography";
import Card from "@mui/material/Card";
import MDInput from "../../components/MDInput";
import UBKfile from "../../components/UBKfile";
// import Visitoredit from "layouts/EditPage/Visitoredit";
import { ConfigFile } from "../../services/ConfigFile";
import UBKSubmit from "../../components/UBKSubmit";
import toast, { Toaster } from "react-hot-toast";
import useSWR, { mutate as globalMutate } from "swr";
import { Table, Image } from "antd";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";
import { Drawer } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
// import SelectRequired from "../../components/UBKSelect/SelectRequired";

import {
  getNewData,
  addData,
  deleteData,
  updateData,
  getadmindataUrl,
  getAdminbranchDataUrl as cachekey
} from "../../Api/api";

import { addOptions, deleteTodoOptions } from "../../Api/apiOption";
// import EditBranch from "./EditBranch ";
import UBKCheckbox from "../../components/UBKCheckbox";
import { useNavigate } from "react-router-dom";

const EditableCell = ({
  dataIndex,
  title,
  record,
  children,
  ...restProps
}) => {
  return (
    <td {...restProps}>
      <div style={{display:"flex",marginLeft:"10px"}}>{children}</div>
    </td>
  );
};

// ==========MAIN FUNCTION ======================



function BranchSettings() {
  const path = ConfigFile.BaseUrl;
  const navigate=useNavigate();
  //   const [classnme, setclassnme] = useState("");
  //   const [open, setOpen] = useState(false);
  const [img, setImage] = useState();
  //   const [id, selectedId] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });



  const {
    isLoading: menuLoading,
    error: menuError,
    data: permissionMenu
  } = useSWR("/admin/Admin/getadminMenu", getNewData);
  const {
    isLoading,
    error,
    data: newData,
    mutate,
  } = useSWR(cachekey, getNewData);


  

  const columns = [
    {
      title: 'Branch Name',
      dataIndex: 'branch_name',
    },
    {
      title: 'Exam Settings',
      dataIndex: 'total_student',
    },
   
   
     {
       title: 'Exam Template',
      
       render: (item, record, index) => <div onClick={() => editClick(record.id)} style={{ fontSize: "11px" }}>
       
         <IconButton>
           <InfoIcon sx={{ color: "#3892ee" }} fontSize="small" />
        </IconButton>
      
       </div>,
     },

  ];
  const editClick = (id) => {

    navigate("/TemplateSettings");
  };

 

  return (
    <DashboardLayout>
      <DashboardNavbar />
    
      <Toaster toastOptions={{ position: "top-center" }} />
      <MDBox pt={8} pb={1}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={1}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Branch List
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
              
                <>
                  <Table
                    components={{
                      body: {
                        cell: EditableCell,
                      },
                    }}
                    style={{ margin: "50px" }}
                    columns={columns}
                    bordered={true}
                    rowKey={(record) => record.branch_id}
                    dataSource={newData?.data}
                    loading={isLoading}
               
                  />
                </>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default BranchSettings;
